export function buildTabUidMap(template) {
  const map = {}
  const tabs = template?.dynamic_sections?.tabs || []
  tabs.forEach((t) => {
    if (t?.tab_name && t?.uid) map[t.tab_name] = t.uid
  })
  return map
}

export function getTabIdByNameSafe(template, tabUidByName, tabName) {
  if (tabUidByName && tabUidByName[tabName]) return tabUidByName[tabName]
  const tabs = template?.dynamic_sections?.tabs || []
  const found = tabs.find((t) => t.tab_name === tabName)
  return found?.uid || ''
}
